import React from 'react';
import Reflux from 'reflux';
import HomePage from './pages/HomePage';
import TopicPage from './pages/TopicPage';
import NewTopicPage from './pages/NewTopicPage';
import ProfilePage from './pages/ProfilePage';
import NotFoundPage from './pages/NotFoundPage';
import SearchPage from './pages/SearchPage';
import NotifPage from './pages/NotifPage';
import ConditionsPage from './pages/conditions/ConditionsPage';
import EditProfilePage from './pages/EditProfilePage';
import AppStore from './AppStore';
import ModalActions from './actions/ModalActions';
import AppActions from './AppActions';
import history from './history';
import ReactGA from 'react-ga';
import ProfileActions from './actions/ProfileActions';
import './App.css';
import {
  Router,
  Route,
  Switch
} from 'react-router-dom';

ReactGA.initialize(process.env.REACT_APP_GA_ID, { debug: false });
ReactGA.set({ page: window.location.pathname + window.location.search });
ReactGA.pageview(window.location.pathname + window.location.search);

history.listen(function (location) {
    window.scrollTo(0, 0);
    AppActions.verifyCreatorHash();
    ModalActions.changeSearchModalStatus(false);
    AppActions.disableEdition();
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
    AppActions.getUnreadedNotifications();
    let pathname = window.location.pathname.split('/');
    if (pathname[1] === 'p') {
        ProfileActions.clearProfile(pathname[2]);
    }
});

class App extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {redirectTo: false};
        this.store = AppStore;
    }

    componentDidMount () {
        AppActions.verifyCreatorHash();
        window.onfocus = function () {
            let link;
            link = document.querySelector('link[rel*="icon"]');
            link['href'] = '/images/favico-in.png';
        };
        window.onblur = function () {
            let link;
            link = document.querySelector('link[rel*="icon"]');
            link['href'] = '/images/favicon-out.png';
        };
    }

    logPageView = () => {
        ReactGA.set({ page: window.location.pathname + window.location.search });
        ReactGA.pageview(window.location.pathname + window.location.search);
    }
    render () {
        return (
          <Router history={history} >
            <Switch>
              <Route exact path='/' render={(props) => { return <HomePage />; }} />
              <Route exact path='/now/:page' render={(props) => { return <HomePage page={props.match.params.page} />; }} />
              <Route path='/new' render={(props) => { return <NewTopicPage />; }} />
              <Route path='/terms&conditions' render={() => { return <ConditionsPage />; }} />
              <Route path='/notfound' render={(props) => { return <NotFoundPage />; }} status={404} />
              <Route path='/search/:query' render={(props) => { return <SearchPage query={props.match.params.query} />; }} />
              <Route path='/notifications' render={(props) => { return <NotifPage />; }} />
              <Route path='/config' render={(props) => { return <EditProfilePage />; }} />
              <Route path='/p/:username/:section?' render={(props) => { return <ProfilePage username={props.match.params.username} section={props.match.params.section} />; }} />
              <Route path='/daily/:autogenerateTitle' render={(props) => { return <TopicPage disableCreation disableArrows autogenerateTitle={props.match.params.autogenerateTitle} />; }} />
              <Route path='/topic/:topicId' render={(props) => { return <TopicPage topicId={props.match.params.topicId} />; }} />
              <Route path='/new-topic/:title' render={(props) => { return <TopicPage title={props.match.params.title} disableCreation disableArrows />; }} />
              <Route component={NotFoundPage} status={404} />
            </Switch>
          </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js